/** The sales form: every Enterprise / "Contact sales" link (pricing, /bar, home, /select-plan, the processing
 * meter past Studio). Not the access form (`VVwyeUrj`), which is how a visitor asks for an account. */
export const SALES_FORM_URL = 'https://form.typeform.com/to/sl2857Ld'
